import { APP_STORE_URL, PLAY_STORE_URL } from 'utils/constants';

/**
 * Trả về tên hệ điều hành di động (ios, android) hoặc null nếu là desktop
 */
export const getMobileOS = (): 'ios' | 'android' | 'other' | null => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Kiểm tra iOS (iPhone, iPad, iPod)
  // Lưu ý: iPad chạy iPadOS 13+ có User Agent giống Mac, nên cần check thêm maxTouchPoints
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  // Kiểm tra iPad Pro chạy iPadOS (thường bị nhận nhầm là Mac)
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }

  // Kiểm tra Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // Kiểm tra các thiết bị di động khác (Windows Phone, v.v.)
  if (/Mobi|Tablet|Mobile|Opera Mini/i.test(userAgent)) {
    return 'other';
  }

  return null;
};

export const isIOS = () => getMobileOS() === 'ios';
export const isAndroid = () => getMobileOS() === 'android';

// Webview của Zalo/Facebook/Instagram/... thường chặn custom scheme
export const isInAppBrowser = (ua = navigator.userAgent) => /Zalo|FBAN|FBAV|FB_IAB|Instagram|Line\/|TikTok/i.test(ua);

/**
 * Đổi URL web sang path mà BuyerMobile hiểu (BuyerMobile/App/Navigation/DeepLinkConfig.ts).
 * Trang app không có → '' (home app).
 */
export const toAppPath = (pathname: string, productId?: string) => {
  if (pathname.startsWith('/cart')) return 'cart';

  if (pathname.startsWith('/favorite')) return 'favorites';

  if (pathname.startsWith('/products/')) return productId ? `products/${productId}` : '';

  return '';
};

/**
 * Mở app đúng path, chưa cài thì về store.
 * Android: intent:// tự fallback về Play Store.
 * iOS: luôn vào App Store (chốt với PO/design). Safari không cho biết máy đã cài app chưa, thử kamereo://
 * thì máy chưa cài bị báo lỗi "địa chỉ không hợp lệ". Trang App Store tự hiện nút "Mở" nếu đã cài.
 */
// ponytail: iOS mất deep link đúng màn hình (appPath bỏ qua); mở lại khi có universal link/Branch
export const openApp = (appPath = '') => {
  const os = getMobileOS();

  if (os === 'android' && !isInAppBrowser()) {
    window.location.href = `intent://${appPath}#Intent;scheme=kamereo;package=vn.kamereo.buyer;S.browser_fallback_url=${encodeURIComponent(
      PLAY_STORE_URL,
    )};end`;

    return;
  }

  window.location.href = os === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
};
